import { render, staticRenderFns } from "./courseSuccess.vue?vue&type=template&id=6f464764&scoped=true&"
import script from "./courseSuccess.vue?vue&type=script&lang=js&"
export * from "./courseSuccess.vue?vue&type=script&lang=js&"
import style0 from "./courseSuccess.vue?vue&type=style&index=0&id=6f464764&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f464764",
  null
  
)

export default component.exports